import React, { useContext, useEffect, useState } from "react";
import { FilterContext } from "../../context/Filter";
import { fetchCouponPopupExpiredDataPVIN } from "./PvinKip";

const ExpiredTataCareCuponTable = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [expiredCuponData, setExpiredCuponData] = useState([]);

  const fetchExpiredCuponData = async () => {
    try {
      const response = await fetchCouponPopupExpiredDataPVIN(parArn, childArn);
      setExpiredCuponData(response || []);
    } catch (error) {
      console.error("Error fetching expired coupon data:", error);
    }
  };

  useEffect(() => {
    if (parArn || childArn) {
      fetchExpiredCuponData();
    }
  }, [parArn, childArn]);

  return (
    <div className="overflow-x-auto mt-4">
      <table className="min-w-full border border-gray-300 rounded-lg shadow-md">
        <thead className="bg-[#007BC0] text-white">
          <tr>
            <th className="px-6 py-3 border text-center font-semibold">
              Chassis No.
            </th>
            <th className="px-6 py-3 border text-center font-semibold">
              Expired Tata Care Cupon
            </th>
          </tr>
        </thead>
        <tbody>
          {expiredCuponData && expiredCuponData.length > 0 ? (
            expiredCuponData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-6 py-3 border text-center">
                  {item.chassis_no || "-"}
                </td>
                <td className="px-6 py-3 border text-center">
                  {item.total_amount_coupon_expired ?? "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={2}
                className="text-center py-4 text-gray-500 border"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ExpiredTataCareCuponTable;
